var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3"},[_c('hr',{staticStyle:{"height":"1px","width":"100%"}})])
}]

export { render, staticRenderFns }